define('models/user/register/address',[ 'backbone' ], function(Backbone){

    var RegisterAddress = Backbone.Model.extend({

        urlRoot: function(){            
            
            if(this.instanceURL){
                return this.instanceURL;
            } else {
                return pf.userURL + 's/Wellness';
            }

        },

        initialize: function(options){
            options = options || {};

            this.instanceURL = options.instanceURL;

            this.A = options.AddressLine1 || options.A;
            this.C = options.City || options.C;
            this.S = options.State || options.S;
            this.SID = options.StateID || options.SID;
            this.Z = options.ZipCode || options.Z;
            this.PN = options.PhoneNumber || options.PN;
            this.O = options.Optional || options.O;
        },

        save: function(attributes, options){
            options = options || {};

            attributes = attributes || {};

            var data = {};

            data.A = this.attributes.A;
            data.C = this.attributes.C;
            data.S = this.attributes.S;
            data.SID = this.attributes.SID;
            data.Z = this.attributes.Z;
            data.PN = this.attributes.PN;
            data.O = this.attributes.O;
            
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return RegisterAddress;
});

